import {
    useEffect, useState
} from 'react';
import {
    Label
} from 'shared/components/ui/label';
import {
    Card, CardContent, CardDescription, CardHeader, CardTitle
} from 'shared/components/ui/card';
import {
    secretKeysService
} from 'shared/api';
import {
    useParams
} from 'react-router-dom';
import {
    AppLoader
} from 'shared/components/LoaderSpinner';
import {
    Badge
} from 'shared/components/ui/badge';
import {
    Alert,
    AlertDescription
} from 'shared/components/ui/alert';
import ConfigFieldsDisplay from './config-fields-display';

const fields = [{
    label: 'Host',
    value: 'host',
    copyable: true,
}, {
    label: 'Port',
    value: 'port',
    copyable: true,
}, {
    label: 'Password',
    value: 'password',
    copyable: true,
    type: 'masked',
}];

export default function RedisKeys() {
    const [redisKeys, setRedisKeys] = useState({
        databaseType: '',
        host: '',
        port: '',
        password: '',
    });
    const [loading, setLoading] = useState(true);

    const {
        oragID
    } = useParams();

    const getRedisKeys = () => {
        secretKeysService.getConfigDetails(oragID, 'redis')
            .then((res) => {
                setRedisKeys(res.data.redisKeys);
            }).catch(() => {

            }).finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        getRedisKeys();
    }, []);

    if (loading) {
        return <div className='flex flex-grow flex-col justify-center items-center'> <AppLoader size={50} /> </div>;
    }

    return (
        <Card>
            <CardHeader>
                <CardTitle>Redis Keys</CardTitle>
                <CardDescription>
                    Mange your Redis connection common and dedicated database.
                </CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
                <div className="space-y-3">
                    <div className="space-y-2">
                        <Label htmlFor={'db-store-type'}> Redis Store Type: </Label>
                        <Badge variant="outline" className="text-sm">{redisKeys.databaseType}</Badge>
                    </div>
                </div>

                {redisKeys.databaseType === 'dedicated' ? (
                    <div className="space-y-3">
                        {fields.length > 0 ? (
                            <ConfigFieldsDisplay fields={fields.map((item) => ({
                                ...item,
                                value: redisKeys[item.value] || ''
                            }))} />
                        ) : (
                            <div className="py-8 text-center text-muted-foreground">
                                <p>Connection guide documentation will be displayed here.</p>
                            </div>
                        )}
                    </div>
                ) : (
                    <Alert>
                        <AlertDescription>
                            Please contact our customer service for assistance with Dedicated configuration. Our team will
                            help you set up the advanced features.
                        </AlertDescription>
                    </Alert>
                )}

            </CardContent>
        </Card>
    );
}